import {TweenMax, TimelineLite} from "gsap";
class AnimTextMarker{
	constructor(target) {
		this.target = target;
	}

	mark(){
		$(this.target).prepend('<span class="js_curtain"></span>');
		this.curtain = $('.js_curtain', $(this.target));
		this.text = $('.js_curtain_text', $(this.target));
		this.tl = new TimelineMax();
	}

	draw(){
		this.tl.set(this.curtain, {transformOrigin: '0% 50%', autoAlpha: 0.5 })
		.to(this.curtain, 0.4, {scaleX: 1, autoAlpha: 1, ease: Back.easeOut.config(1)})
		.set(this.curtain, {transformOrigin: '100% 50%'})
		.set(this.text, {autoAlpha: 1})
		.to(this.curtain, 0.4, {
			scaleX: 0,
			ease:Quint.easeOut,
			onComplete:function(){
				return new Promise((resolve, reject) => {
					let result = 'ok';
					resolve(result);
				});
			}
		});
	}

	drawPromise(){
		let tl = this.tl;
		return new Promise(function(resolve) {
			//alternate syntax for adding a callback
			tl.eventCallback("onComplete", function() {
				resolve(true);
			});
		});
	}

	fadeRtoL(item){
		TweenMax.staggerFromTo( $(item), 0.75, {autoAlpha: 0, x: 10 }, {autoAlpha: 1, x: 0, ease: Back.easeOut }, 0.2);
	}
	fadeLtoR(item){
		TweenMax.staggerFromTo( $(item), 0.75, {autoAlpha: 0, x: -10}, {autoAlpha: 1, x: 0, ease: Back.easeOut }, 0.2);
	}
	fadeOutRtoL(item){
		TweenMax.staggerTo( $(item), 0.75, {autoAlpha: 0, x: -10, ease: Back.easeOut }, 0.2);
	}
	fadeOutLtoR(item){
		TweenMax.staggerTo( $(item), 0.75, {autoAlpha: 0, x: 10, ease: Back.easeOut }, 0.2);
	}
}
module.exports = AnimTextMarker;



// WEBPACK FOOTER //
// ./dev/js/scripts/AnimTextMarker.js